import { Region } from './Tests.model';

const DNSUrls: Record<Region, Array<string>> = {
  US: [
    'https://rt.freshcaller.com',
    'https://catchconsultantshelp.freshworks.com',
    'https://s3.amazonaws.com',
    'https://assets.freshcaller.com',
    'https://wchat.freshchat.com',
    'https://assetscdn-wchat.freshchat.com',
    'https://heapanalytics.com',
    'https://headway-widget.net',
    'https://cdn.headwayapp.co',
    'https://api.appcues.net',
    'https://fast.appcues.com',
    'https://static.freshdev.io',
    'https://dash.freshworks.com',
    'https://fonts.gstatic.com',
    'https://www.gstatic.com',
    'https://freshservice-us.freshreports.com',
    'https://media.twiliocdn.com',
  ],
  EU: [
    'https://rt-euc.freshcaller.com',
    'https://accounts.freshworks.com',
    'https://s3.eu-central-1.amazonaws.com',
    'https://assets.freshcaller.com',
    'https://wchat.freshchat.com',
    'https://assetscdn-wchat.freshchat.com',
    'https://heapanalytics.com',
    'https://app.getbeamer.com',
    'https://static.getbeamer.com',
    'https://api.appcues.net',
    'https://fast.appcues.com',
    'https://static.freshdev.io',
    'https://browser.sentry-cdn.com',
    'https://freshcaller-euc.freshreports.com',
    'https://static.freshreports.com',
    'https://media.twiliocdn.com',
  ],
  AUS: [
    'https://rt-au.freshcaller.com',
    'https://accounts.freshworks.com',
    'https://au-fone-frontend.s3-ap-southeast-2.amazonaws.com',
    'https://assets.freshcaller.com',
    'https://heapanalytics.com',
    'https://app.getbeamer.com',
    'https://static.getbeamer.com',
    'https://api.appcues.net',
    'https://fast.appcues.com',
    'https://static.freshdev.io',
    'https://browser.sentry-cdn.com',
    'https://freshcaller-au.freshreports.com',
    'https://media.twiliocdn.com',
  ],
  IN: [
    'https://rt-in.freshcaller.com',
    'https://accounts.freshworks.com',
    'https://in-fone-frontend.s3.ap-south-1.amazonaws.com',
    'https://assets.freshcaller.com',
    'https://heapanalytics.com',
    'https://app.getbeamer.com',
    'https://static.getbeamer.com',
    'https://api.appcues.net',
    'https://fast.appcues.com',
    'https://static.freshdev.io',
    'https://browser.sentry-cdn.com',
    'https://freshcaller-in.freshreports.com',
    'https://media.twiliocdn.com',
  ],
  MEC: [
    'https://rt-mec.freshcaller.com',
    'https://accounts.freshworks.com',
    'https://mec-fone-frontend.s3.me-central-1.amazonaws.com',
    'https://assets.freshcaller.com',
    'https://wchat.freshchat.com',
    'https://assetscdn-wchat.freshchat.com',
    'https://heapanalytics.com',
    'https://app.getbeamer.com',
    'https://static.getbeamer.com',
    'https://api.appcues.net',
    'https://fast.appcues.com',
    'https://static.freshdev.io',
    'https://browser.sentry-cdn.com',
    'https://freshcaller-mec.freshreports.com',
    'https://media.twiliocdn.com',
  ],
};

const DNS_Timeout = 10000; //10 seconds.

const MEDIA_SERVER_ERROR_CODE = 31003;

export { DNSUrls, DNS_Timeout, MEDIA_SERVER_ERROR_CODE };
